// extracted by mini-css-extract-plugin
export default {"form":"ConnectForm_form__D4+QJ","mandatory":"ConnectForm_mandatory__-tOZc","footer":"ConnectForm_footer__wwHdF","button":"ConnectForm_button__Bdk7s"};